import React, { useCallback, useEffect } from "react";
//import {Prompt} from "react-router-dom";
import { toast } from "react-hot-toast";
const message = "Les modifications que vous avez apportées ne seront peut-être pas enregistrées.";
export const AdminEditFormHandler = ({ form, children }) => {
    const { formState: { isDirty, errors } } = form;
    const errorArray = Object.entries(errors);
    const beforeUnload = useCallback((e) => {
        if (isDirty) {
            let confirmationMessage = "\o/";
            e.returnValue = confirmationMessage;
            return confirmationMessage;
        }
        return null;
    }, [isDirty, message]);
    useEffect(() => {
        window.addEventListener('beforeunload', beforeUnload);
        return () => {
            window.removeEventListener('beforeunload', beforeUnload);
        };
    }, [beforeUnload]);
    useEffect(() => {
        if (errorArray.length > 0) {
            toast.error(React.createElement("div", null,
                "Il y a une ",
                errorArray.length,
                " erreur(s) : ",
                React.createElement("br", null),
                errorArray.map((value, index) => {
                    var _a, _b, _c;
                    return React.createElement("div", { key: index },
                        React.createElement("b", null,
                            value[0],
                            " : "),
                        ((_b = (_a = value[1]) === null || _a === void 0 ? void 0 : _a.message) === null || _b === void 0 ? void 0 : _b.length) > 0 ? (_c = value[1]) === null || _c === void 0 ? void 0 : _c.message : (value[1].type === "required" && "Ce champs est requis"),
                        React.createElement("br", null));
                })));
        }
    }, [errorArray]);
    return React.createElement(React.Fragment, null, children);
};
//# sourceMappingURL=index.js.map